module.exports = __webpack_public_path__ + "media/images/v2/countdown-f3bd15e23413804b9e7c5da1cbbe9e5c.png";